import {createStore, combineReducers, applyMiddleware} from 'redux';
import thunk from 'redux-thunk';
import {reduxLib} from 'lib.front';
import appReducer from './appGen';
import constantesReducer from './constantes';

const rootReducer = combineReducers({
   auth: reduxLib.auth.reducer,
   loading: reduxLib.loading.reducer,
   modal: reduxLib.modal.reducer,
   msg: reduxLib.msg.reducer,
   overlay: reduxLib.overlay.reducer,
   sidebar: reduxLib.sidebar.reducer,
   appGen: appReducer,
   constantes: constantesReducer
});

const store = createStore(rootReducer, applyMiddleware(thunk));
export default store;
